import React, {
    CSSProperties,
    useState,
    useEffect,
    FC,
} from 'react';

interface IImageWithFallbackProps {
    imageUrl: string;
    className?: string;
    style?: CSSProperties;
    fallbackImageUrl?: string;
    isBackground?: boolean;
    onImageLoadError?: () => void;
    alt?: string;
}

export const ImageWithFallback: FC<IImageWithFallbackProps> = ({
    imageUrl = '',
    className = '',
    style = {},
    fallbackImageUrl = '',
    isBackground,
    onImageLoadError,
    alt,
}: IImageWithFallbackProps) => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [hasImageError, setHasImageError] = useState(false);

    useEffect(() => {
        if (!imageUrl) {
            setIsImageLoaded(true);
            return undefined;
        }

        const img = new Image();
        img.src = imageUrl;
        img.onload = () => setIsImageLoaded(true);
        img.onerror = () => {
            setHasImageError(true);
            onImageLoadError?.();
        };

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [imageUrl, onImageLoadError]);

    const useFallback = !imageUrl || !isImageLoaded || hasImageError;

    const ImageStyles: CSSProperties = {
        ...(isBackground && {
            backgroundImage: useFallback ? `url(${fallbackImageUrl})` : `url(${imageUrl})`,
            transition: 'background-image 0.3s ease',
        }),
        ...style,
    };

    return (
        <div
            className={className}
            style={isBackground ? ImageStyles : {}}
        >
            {
                !isBackground && (
                    <img
                        src={useFallback ? fallbackImageUrl : imageUrl}
                        alt={alt}
                        style={ImageStyles}
                    />
                )
            }
        </div>
    );
};
